module.exports = __webpack_public_path__ + "media/images/icon/icons8-Change Theme-e702f3cc9bcbb0d129fbfa4a460d092b.png";